import React, {FC} from 'react'
import {StepLoadFile} from './steps/StepLoadFile'
import {StepConfirmData} from './steps/StepConfirmData'
import {StepComplete} from './steps/StepComplete'

const WizardBody = () => {
  return (
    <div className='mx-auto mw-600px w-100'>
      <div className='current' data-kt-stepper-element='content'>
        <StepLoadFile />
      </div>

      <div data-kt-stepper-element='content'>
        <StepConfirmData />
      </div>

      <div data-kt-stepper-element='content'>
        <StepComplete />
      </div>
    </div>
  )
}

export default WizardBody
